import httpClient from "../../../../shared/api/httpClient";

function getLicenseId() {
  try {
    return Number(localStorage.getItem("sabi_empresa_id")) || 1;
  } catch {
    return 1;
  }
}

const BASE_PATH = (licenseId) =>
  `/admin/licenses/${licenseId}/hr/calendar/event-categories`;

export const EventCategoriesApi = {
  list: (licenseId = getLicenseId()) => {
    return httpClient.get(BASE_PATH(licenseId));
  },

  create: (data, licenseId = getLicenseId()) => {
    return httpClient.post(BASE_PATH(licenseId), data);
  },

  update: (id, data, licenseId = getLicenseId()) => {
    return httpClient.patch(`${BASE_PATH(licenseId)}/${id}`, data);
  },

  remove: (id, licenseId = getLicenseId()) => {
    return httpClient.delete(`${BASE_PATH(licenseId)}/${id}`);
  },
};

export default EventCategoriesApi;
